import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropFileComponent } from './components/drop-file/drop-file.component';
import { FileUploadModule } from 'primeng/fileupload';
import { ProgressBarModule } from 'primeng/progressbar';
import { SharedUiButtonsModule } from '@shared/ui/buttons';
import { SharedUiBadgesModule } from '@shared/ui/badges';
import { SharedUiIconsModule } from '@shared/ui/icons';
import { SharedFeatureTranslateModule } from '@shared/feature/translate';

@NgModule({
  imports: [CommonModule, FileUploadModule, ProgressBarModule, SharedUiButtonsModule, SharedUiBadgesModule, SharedUiIconsModule, SharedFeatureTranslateModule],
  declarations: [DropFileComponent],
  exports: [DropFileComponent],
  providers: [],
})
export class SharedFeatureDropFileModule {}
